/**
 * FF Hero Animated Content - IntersectionObserver-based scroll animation
 *
 * Reads config from data attributes on [data-ff-animate] elements:
 * - data-ff-animate-threshold: viewport % required to trigger (0-100)
 * - data-ff-animate-once: if present, animation plays only once
 * - data-ff-stagger: if present, animate grid children sequentially
 *
 * CSS classes toggled:
 * - .ff-animated--visible: added when element enters viewport
 * - .ff-stagger-active: added when stagger mode is set up
 * - .ff-hero-stagger-child: added to each grid child for stagger
 *
 * CSS custom property set per stagger child:
 * - --ff-stagger-idx: child index (0, 1, 2...) for transition-delay calc
 */
(function() {
  'use strict';

  if (window.__ffHeroAnimatedInit) return;
  window.__ffHeroAnimatedInit = true;

  function setupStagger(el) {
    var gridSelector = '.ff-d-grid, .ff-d-flex, .ff-d-grid--mb, .ff-d-flex--mb, .ff-custom-grid-block';
    var gridEl = el.matches(gridSelector) ? el : el.querySelector(gridSelector);
    if (!gridEl) return;

    var children = Array.from(gridEl.children);
    children.forEach(function(child, i) {
      child.classList.add('ff-hero-stagger-child');
      child.style.setProperty('--ff-stagger-idx', i);
    });

    el.classList.add('ff-stagger-active');
  }

  function initElement(el) {
    if (el.classList.contains('ff-animated--visible')) return;

    var threshold = Math.min(Math.max(parseInt(el.dataset.ffAnimateThreshold) || 20, 0), 100) / 100;
    var once = el.hasAttribute('data-ff-animate-once');
    var hasStagger = el.hasAttribute('data-ff-stagger');

    if (hasStagger) {
      setupStagger(el);
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          el.classList.add('ff-animated--visible');
          if (once) observer.unobserve(el);
        } else if (!once) {
          el.classList.remove('ff-animated--visible');
        }
      });
    }, { threshold: threshold });

    observer.observe(el);
  }

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('[data-ff-animate]').forEach(function(el) {
        el.classList.add('ff-animated--visible');
      });
      return;
    }

    document.querySelectorAll('[data-ff-animate]').forEach(initElement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
